import { render, staticRenderFns } from "./fmcs.vue?vue&type=template&id=24fa6ee7&scoped=true"
var script = {}
import style0 from "./fmcs.vue?vue&type=style&index=0&id=24fa6ee7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fa6ee7",
  null
  
)

export default component.exports